import API_BASE from "../config";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api/albums";

// Resolve a stored album image url to a browser src. Uploaded images are
// stored as "/img/albums/x.jpg" (served by the API host); full http(s) URLs
// (e.g. external/seed images) are used as-is.
export const albumImageSrc = (u) => {
  if (!u) return "";
  if (/^(https?:)?\/\//i.test(u) || u.startsWith("data:")) return u;
  return API_BASE + (u.startsWith("/") ? u : "/" + u);
};

// Public reads (published only). Staff tokens also reveal unpublished albums.
const getAll = (params = {}) =>
  axios.get(API_URL, { params, headers: authHeader() });

const get = (id) =>
  axios.get(`${API_URL}/${id}`, { headers: authHeader() });

// Build multipart FormData from an album payload.
//   fields: { title, description, published, removeImageIds, order, captions }
//   files:  array<File> (new uploads under field "images")
const buildForm = (fields = {}, files = []) => {
  const fd = new FormData();
  if (fields.title !== undefined) fd.append("title", fields.title);
  if (fields.description !== undefined) fd.append("description", fields.description ?? "");
  if (fields.published !== undefined) fd.append("published", fields.published ? "true" : "false");
  if (fields.removeImageIds) fd.append("removeImageIds", JSON.stringify(fields.removeImageIds));
  if (fields.order) fd.append("order", JSON.stringify(fields.order));
  if (fields.captions) fd.append("captions", JSON.stringify(fields.captions));
  if (fields.newCaptions) fd.append("newCaptions", JSON.stringify(fields.newCaptions));
  (files || []).forEach((f) => fd.append("images", f));
  return fd;
};

// Moderator / admin writes (multipart/form-data).
const create = (fields, files, onProgress) =>
  axios.post(API_URL, buildForm(fields, files), {
    headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });

const update = (id, fields, files, onProgress) =>
  axios.put(`${API_URL}/${id}`, buildForm(fields, files), {
    headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });

const remove = (id) =>
  axios.delete(`${API_URL}/${id}`, { headers: authHeader() });

const removeImage = (albumId, imageId) =>
  axios.delete(`${API_URL}/${albumId}/images/${imageId}`, { headers: authHeader() });

const AlbumService = { getAll, get, create, update, remove, removeImage };

export default AlbumService;
